'use es6';

import { Set as ImmutableSet } from 'immutable';
export const getBreakdownColumns = (breakdownField, data) => {
  const breakdownValues = data.getIn(['primary', 'data', 'data']).reduce((collect, point /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */) => collect.concat(point.keySeq().toList()), ImmutableSet());
  return data.getIn(['primary', 'data', 'properties', breakdownField, 'references']).entrySeq().toList().filter(([value]) => value !== 'deal_activity' && breakdownValues.has(value)).sortBy(([, val]) => val.get('displayOrder')).map(([key]) => key);
};